import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getCategory } from '../Api'

export default generateApiAction({
  baseType: Types.CATEGORIES.GET,
  api: getCategory,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/categories/GetAction.js